export type AddNotification = (
  message: string,
  type: "JSON" | "TEXT",
  level?: "normal" | "warning" | "error",
  duration?: number
) => void

let addNotificationImpl: AddNotification | null = null

export const setNotificationHandler = (handler: AddNotification | null) => {
  addNotificationImpl = handler
}

export const notify: AddNotification = (message, type, level, duration) => {
  if (!addNotificationImpl) return
  addNotificationImpl(message, type, level, duration)
}
